<template>
    <div class="w-screen h-screen flex justify-center items-center">
        <div class="w-full max-w-sm z-1">
            <div class="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
                <slot />
            </div>
        </div>
    </div>
</template>

<script>
export default {

};
</script>

<style>
body {
    background-color: #eef0f5;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3E%3Cg fill='%23e8ebf3' fill-opacity='1'%3E%3Cpath fill-rule='evenodd' d='M0 0h4v4H0V0zm4 4h4v4H4V4z'/%3E%3C/g%3E%3C/svg%3E");
}
</style>